import React__default from 'react';
import { useMediaQuery, Box } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import StyledBusinessFilterLayout, { classes } from './index.styled.js';
import StyledBusinessFilterLayoutMobile from './mobile.styled.js';

var BusinessFilterLayout = function (_a) {
    var active = _a.active, setActive = _a.setActive, children = _a.children, className = _a.className, id = _a.id, _b = _a.testId, testId = _b === void 0 ? "businessFilterLayout" : _b, sx = _a.sx;
    var t = useTranslation("refront-components").t;
    var isDownSm = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    if (active && isDownSm) {
        return (React__default.createElement(StyledBusinessFilterLayoutMobile, { open: active, onClose: function () { return setActive(false); }, className: clsx(className, "BusinessFilterLayout") },
            React__default.createElement(Box, { sx: {
                    padding: function (theme) { return theme.spacing(1); },
                    display: "flex",
                    justifyContent: "space-between",
                    fontWeight: "bold"
                } }, t("components.businessFilter.businessFilterSidebar.title")),
            React__default.createElement(Box, { className: classes.content }, active && children)));
    }
    return (React__default.createElement(StyledBusinessFilterLayout, { id: id, className: clsx(className, "BusinessFilterLayout"), "aria-hidden": !active, tabIndex: active ? 0 : -1, "data-testid": testId, active: active, sx: sx },
        React__default.createElement(Box, { className: classes.content }, active && children)));
};

export { BusinessFilterLayout as default };
//# sourceMappingURL=index.js.map
